import ErrorScreen from '../components/app/error';
import { AssessmentButtons } from '../components/assessment/shared';
import { Icon } from '../components/icon/icon';

const Page500 = () => (
  <ErrorScreen
    title="Something went wrong."
    subtitle="Please try again in a moment."
    icon={
      <Icon
        icon="HexagonExclamation"
        styleType="duotone"
        color="primary"
        fontSize="large"
      />
    }
  >
    <AssessmentButtons
      primary={{
        children: 'Back to talkiatry.com',
        variant: 'outlined',
        type: 'button',
        endIcon: null,
        onClick: () => {
          window.location.assign('https://www.talkiatry.com/');
        },
      }}
    />
  </ErrorScreen>
);

export default Page500;
